// @ts-nocheck
import type React from 'react';

import styled from '@emotion/styled';

import { colors, fonts } from '../../styles';

interface CaptionFactoryProps {
  color: string;
  fontWeight?: number;
  ellipsis?: boolean;
}

export interface CaptionProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  ellipsis?: boolean;
  id?: string;
  color?: string;
}

const CaptionFactory = styled('span')<CaptionFactoryProps>`
  color: ${(props) => props.color};
  font-size: ${fonts.size.smallest};
  font-weight: ${(props) => props.fontWeight || fonts.weight.regular};
  line-height: 1.42;
  letter-spacing: normal;
  ${(props) =>
    props.ellipsis &&
    'white-space: nowrap; overflow: hidden; text-overflow: ellipsis;'};
`;

export const CaptionDefault: React.FC<CaptionProps> = (props: CaptionProps) => (
  <CaptionFactory color={colors.gray.dark} {...props} />
);
export const CaptionMedium: React.FC<CaptionProps> = (props: CaptionProps) => (
  <CaptionFactory
    color={colors.gray.dark}
    fontWeight={fonts.weight.medium}
    {...props}
  />
);
export const CaptionBold: React.FC<CaptionProps> = (props: CaptionProps) => (
  <CaptionFactory
    color={colors.black}
    fontWeight={fonts.weight.bold}
    {...props}
  />
);
export const CaptionWarning: React.FC<CaptionProps> = (props: CaptionProps) => (
  <CaptionFactory color={colors.warning.default} {...props} />
);
export const CaptionError: React.FC<CaptionProps> = (props: CaptionProps) => (
  <CaptionFactory color={colors.error.default} {...props} />
);
export const CaptionFocus: React.FC<CaptionProps> = (props: CaptionProps) => (
  <CaptionFactory color={colors.black} {...props} />
);
export const CaptionSuccess: React.FC<CaptionProps> = (props: CaptionProps) => (
  <CaptionFactory color={colors.success.default} {...props} />
);
